import React, { useState, useEffect } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import ptBR from "date-fns/locale/pt-BR";
import { toast } from "react-toastify";
import "react-big-calendar/lib/css/react-big-calendar.css";

const locales = { "pt-BR": ptBR };

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const messages = {
  date: "Data",
  time: "Hora",
  event: "Evento",
  allDay: "Dia inteiro",
  week: "Semana",
  work_week: "Semana de trabalho",
  day: "Dia",
  month: "Mês",
  previous: "Anterior",
  next: "Próximo",
  today: "Hoje",
  agenda: "Agenda",
  noEventsInRange: "Nenhum evento neste intervalo",
  showMore: (total) => `+${total} mais`,
};

function CalendarioCompartilhado() {
  const [events, setEvents] = useState([]);

  const fetchAgendaGeral = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/agendaCompartilhada`
      );
      if (!response.ok) {
        throw new Error("Erro ao buscar agenda compartilhada.");
      }

      const data = await response.json();

      const newEvents = data.map((item) => {
        const dataUTC = new Date(item.data_inicio);
        const dataLocal = new Date(
          dataUTC.getTime() + dataUTC.getTimezoneOffset() * 60000
        );
        const dia = format(dataLocal, "yyyy-MM-dd");

        const [year, month, day] = dia.split("-");
        const [hour, minute] = item.hora_inicio.split(":");

        const startDate = new Date(year, month - 1, day, hour, minute);
        const endDate = new Date(startDate);
        endDate.setHours(endDate.getHours() + 1);

        return {
          title: item.ocupado
            ? `Consulta (${item.consulta.status}) - ${item.nome_medico}`
            : `Disponível - ${item.nome_medico}`,
          start: startDate,
          end: endDate,
          isOccupied: item.ocupado,
        };
      });

      setEvents(newEvents);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchAgendaGeral();
  }, []);

  return (
    <div>
      <h3>Agenda Compartilhada</h3>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        messages={messages}
        culture="pt-BR"
        defaultView="month"
        selectable={false} // Sem seleção de horários
        eventPropGetter={(event) => ({
          style: {
            backgroundColor: event.isOccupied ? "#dc3545" : "#28a745", // vermelho se ocupado, verde se livre
            color: "white",
          },
        })}
      />
    </div>
  );
}

export default CalendarioCompartilhado;
